import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopMasterKeyComponent } from './components/temp/top-master-key/top-master-key.component';
import { KeyingCombinationComponent } from './keying-combination.component';
import { KeyingCombinationRoutingModule } from './keying-combination.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CombinationConfig, ICombinationConfig } from './configuration/keying.combination.environment.config';
import { KeyingCombinationService } from './keying-combination.service';
import { TopMasterKeyService } from './services/top-master-key-service';

@NgModule({
  declarations: [KeyingCombinationComponent, TopMasterKeyComponent],
  imports: [CommonModule, KeyingCombinationRoutingModule, ReactiveFormsModule, FormsModule],
  exports: [KeyingCombinationComponent, TopMasterKeyComponent],
})
export class KeyingCombinationModule {
  static forRoot(config: ICombinationConfig): ModuleWithProviders<KeyingCombinationModule> {
    return {
      ngModule: KeyingCombinationModule,
      providers: [
        KeyingCombinationService,
        TopMasterKeyService,
        { provide: CombinationConfig, useValue: CombinationConfig.createConfig(config) },
      ],
    };
  }
}
